// we need to create this function, because the API response is
// different on the order details page than in the sync function
// this function takes into account _extBundleLeasePrice and _bundleLeasePrice

export const getPrimaryItems = (bundles: any[]) => {
 	const primaryItems = bundles.filter(
		(
			bundle,
		): bundle is typeof bundle & {
			bundleItem: NonNullable<typeof bundle.bundleItem>;
		} =>
			bundle.bundleItem !== null &&
 			bundle.bundleItem.bundleItemGroup.slug === "primary"
	);

	return primaryItems;
};

export const getBundleWithPrimaryItemAndBundleItems = (
	primaryItems: any[],
	bundles: any[],
) => {
	const bundleWithPrimaryItemAndBundleItems = primaryItems
		.map((primaryItem) => {
			if (!primaryItem.bundleItem.bundle) {
				return null;
			}

			let bundleMatches = bundles.filter((bundleItem) => {
				return (
					bundleItem?.bundleItem?.bundle?.uuid ===
					primaryItem.bundleItem.bundle?.uuid
				);
			});

			return {
				bundleItems: bundleMatches,
				quantity: primaryItem.quantity,
				bundle: {
					...primaryItem.bundleItem.bundle,
				},
			};
		})
		.filter((item): item is NonNullable<typeof item> => item !== null);

	return bundleWithPrimaryItemAndBundleItems;
};

const formatSalesOrderBundlesPreLaunchCommerce = (
	bundle: any,
	salesOrderDetailsItems: { [key: string]: any }[],
) => {
	let bundleItems = [];
	const primaryItem = bundle.bundleItems.find(
		(bundleItem: { [key: string]: any }) => {
			{
				return (
					bundleItem?.bundleItem?.bundleItemGroup &&
					bundleItem?.bundleItem?.bundleItemGroup?.slug === "primary"
				);
			}
		},
	);

	const extPriceBundlePurchase = salesOrderDetailsItems.find(
		(item: { [key: string]: any }) =>
			item?.bundleItem?.uuid === primaryItem?.bundleItem?.uuid,
	)?._extPriceBundlePurchase;

	const extPriceBundlePurchaseLease = salesOrderDetailsItems.find(
		(item: { [key: string]: any }) =>
			item?.bundleItem?.uuid === primaryItem?.bundleItem?.uuid,
	)?._extPriceBundleLease;

	const formatBundleItems = bundle?.bundleItems.map(
		(bundleItem: { [key: string]: any }) => {
			return {
				bundleItem: bundleItem.bundleItem,
				quantity: bundleItem.quantity,
				_extPriceBundleLease: extPriceBundlePurchaseLease,
				_extPriceBundlePurchase: extPriceBundlePurchase,
				uuid: bundleItem.uuid,
			};
		},
	);

	bundleItems = formatBundleItems;

	return {
		bundleItems: bundleItems,
		quantity: bundle.quantity,
		_extPriceBundlePurchase: extPriceBundlePurchase,
		_extPriceBundleLease: extPriceBundlePurchaseLease,
		bundle: {
			name: primaryItem?.bundleItem.bundle.name,
			number: primaryItem?.bundleItem.bundle.number,
			uuid: primaryItem?.bundleItem.bundle.uuid,
			_bundleMicroImages:
				primaryItem?.bundleItem.bundle._bundleMicroImages,
			_imageUrl: primaryItem?.bundleItem.bundle._imageUrl,
			_includedItems: primaryItem?.bundleItem.bundle._includedItems,
		},
	};
};

export default formatSalesOrderBundlesPreLaunchCommerce;
